module.exports = __webpack_public_path__ + "assets/4485ad940aab0e01e0ad8a4d675c885b.png";